import apiClient from '@/api/client';
import { AUTH_ENDPOINTS } from '@/constants/auth';

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export const authApi = {
  async changePassword(input: ChangePasswordInput): Promise<void> {
    await apiClient.patch(AUTH_ENDPOINTS.CHANGE_PASSWORD, input);
  },
};
